import {
  ComponentDefinitionSchema
} from "./chunk-WJYTQIJN.js";

// src/schemas/api.ts
import { Type } from "@sinclair/typebox";
var GenerateDocumentRequestSchema = Type.Object(
  {
    definition: ComponentDefinitionSchema,
    format: Type.Optional(
      Type.Union([
        Type.Literal("docx"),
        Type.Literal("pdf"),
        Type.Literal("html")
      ])
    ),
    options: Type.Optional(
      Type.Object(
        {
          includeMetadata: Type.Optional(Type.Boolean()),
          /**
           * @deprecated No effect. Comments are authored on the components
           * that carry them (see the `comment` prop), so there is nothing for
           * a request-level toggle to switch. Kept so the exported
           * `GenerateDocumentRequest` type still accepts callers that send it.
           */
          includeComments: Type.Optional(
            Type.Boolean({
              deprecated: true,
              description: "Deprecated and ignored. Comments are authored per component via the `comment` prop."
            })
          ),
          trackChanges: Type.Optional(Type.Boolean())
        },
        { additionalProperties: true }
      )
    )
  },
  {
    additionalProperties: false,
    description: "Document generation request"
  }
);
var ValidateDocumentRequestSchema = Type.Object(
  {
    definition: Type.Unknown(),
    strict: Type.Optional(Type.Boolean())
  },
  {
    additionalProperties: false,
    description: "Document validation request"
  }
);
var GenerateDocumentResponseSchema = Type.Object(
  {
    success: Type.Boolean(),
    documentId: Type.Optional(Type.String()),
    downloadUrl: Type.Optional(Type.String()),
    error: Type.Optional(Type.String()),
    metadata: Type.Optional(
      Type.Object(
        {
          pageCount: Type.Optional(Type.Number()),
          wordCount: Type.Optional(Type.Number()),
          generatedAt: Type.Optional(Type.String({ format: "date-time" }))
        },
        { additionalProperties: true }
      )
    )
  },
  {
    additionalProperties: false,
    description: "Document generation response"
  }
);
var ValidateDocumentResponseSchema = Type.Object(
  {
    valid: Type.Boolean(),
    errors: Type.Array(
      Type.Object({
        path: Type.String(),
        message: Type.String(),
        code: Type.Optional(Type.String())
      })
    ),
    warnings: Type.Optional(
      Type.Array(
        Type.Object({
          path: Type.String(),
          message: Type.String(),
          code: Type.Optional(Type.String())
        })
      )
    )
  },
  {
    additionalProperties: false,
    description: "Document validation response"
  }
);

export {
  GenerateDocumentRequestSchema,
  ValidateDocumentRequestSchema,
  GenerateDocumentResponseSchema,
  ValidateDocumentResponseSchema
};
//# sourceMappingURL=chunk-5VX7H4RI.js.map